module.exports = __webpack_public_path__ + "img/external_link.1b0517ab.svg";